// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import router from './router'
import axios from 'axios'
import SIdentify from './components/common/identify.vue'
import * as echarts from 'echarts'

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

axios.defaults.timeout = 5000000 // 请求超时
axios.defaults.baseURL = '/'  // api 即上面 vue.config.js 中配置的地址

Vue.use(ElementUI);
Vue.use(SIdentify);
Vue.prototype.$echarts = echarts
Vue.config.productionTip = false

router.beforeEach((to,from,next)=>{
  let token = sessionStorage.getItem('token')
  if (token) {
    //登录了 跳回登录页 则回跳
    if (to.path === '/') {
      if (token&&typeof(token) !== 'undefined') {
        next({path: '/home/index'})
      } else {
        next()
      }
    } else {
      next()
    }
  } else {
    if (to.path === '/') {
      next()
    } else {
      next({
        path: '/'
      })
    }
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  ElementUI,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js